import { render } from "./StartMorphingText.vue?vue&type=template&id=5b25541a&scoped=true&ts=true"
import script from "./StartMorphingText.vue?vue&type=script&lang=ts"
export * from "./StartMorphingText.vue?vue&type=script&lang=ts"

import "./StartMorphingText.vue?vue&type=style&index=0&id=5b25541a&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b25541a"]])

export default __exports__